import { Component, Input, inject } from '@angular/core';

import { ClientService } from '../../../services/client.service';
import { ToastComponent } from '../../toast/toast.component';
import { Client } from '../../models/client.model';
import { dateRegexp, ee } from '../../constants';
import { setClassInvalidTpl } from '../../functions';
import { ClientGoal } from '../../types';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-add-goal-modal',
  templateUrl: './add-goal-modal.component.html',
  standalone: false
})
export class AddGoalModalComponent {
  toast = inject(ToastComponent);
  private clientService = inject(ClientService);


  @Input() client: Client;

  newGoal: ClientGoal = { id: 1, description: '', dueDate: '', achieved: false };
  dateRegexp = dateRegexp;
  setClassInvalidTpl = setClassInvalidTpl;

  addArrayField(): void {
    const client: Client = {
      _id: this.client._id
    };
    this.clientService.addArrayField(client, this.newGoal, 'goal')
      .pipe(finalize(() => ee.emit('getClient')))
      .subscribe({
        next: res => this.toast.setMessage('Goal added successfully', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

}
